import { useApi, useDebounce } from '@cleartax/wg-library-hooks';
import * as Select from '@cleartax/wg-library-select';
import { useEffect, useState } from 'react';
import { TSearchResultFull } from '../../../../../../pages/services/[planSeoSlug]/api/types';
import { searchApi } from '../header.api';
import { CustomSearchResult } from './custom-search-result';
import { ListSuffix } from './list-suffix';
import { SearchOpenClose } from './search-open-close';
import { getOptionsForSelect } from './utils';

export interface ISearch {
  open?: boolean;
  closeCB?: () => void;
}
export const Search: React.FC<ISearch> = ({ open, closeCB }) => {
  const [searchInputValue, setSearchInputValue] = useState('');
  const [searchItems, setSearchItems] = useState<TSearchResultFull>();

  const searchQuery = useDebounce(searchInputValue, 300);

  const {
    request: getSearchResults,
    data: searchResults,
    isLoading: isSearchResultsLoading,
  } = useApi<TSearchResultFull>({}, searchApi, true);

  useEffect(() => {
    if (searchQuery !== '') getSearchResults(searchQuery);
    else setSearchItems(undefined);
  }, [searchQuery]);

  useEffect(() => {
    if (isSearchResultsLoading === false) setSearchItems(searchResults);
  }, [isSearchResultsLoading]);

  const onEnterCB = (option: Select.option) => {
    if (option.value) {
      window.location.href = `/services/${option.value}/p`;
    }
  };

  return (
    <div className="flex mx-10 w-full relative justify-between sm:mx-0 sm:static sm:w-full sm:h-full">
      <Select.SelectContainer
        options={getOptionsForSelect(searchItems)}
        id={'search-container'}
        onChange={(value) => setSearchInputValue(value)}
        onBlur={(value) => setSearchInputValue(value)}
        value={searchInputValue}
        disableOptionFiltering={true}
        className={'w-full mb-1 sm:w-full sm:h-full'}
      >
        <div className="sm:px-4 sm:sticky sm:top-0 sm:w-full sm:z-10 sm:pt-4 bg-white">
          <Select.SelectInput
            inputPrefix={<SearchOpenClose open={open} closeCB={closeCB} />}
            className="w-full pl-10 overflow-ellipsis sm:h-10"
            placeholder={'Search for services & plans related to ITR, GST...'}
            autoComplete={'off'}
          ></Select.SelectInput>
        </div>

        {searchInputValue ? (
          <Select.SelectOptions
            overrideListClasses={{
              containerClasses:
                'rounded-b-lg absolute z-50 bg-white w-full sm:z-0 sm:h-full sm:rounded-0 sm:relative',
              elementClasses:
                'border border-t-0 break-all border-grey-300 sm:border-l-0 sm:border-r-0 sm:border-dashed sm:max-w-[100vw]',
              lastChildClasses: 'rounded-b-0',
            }}
            renderCustomElement={(option) => (
              <CustomSearchResult
                searchItems={searchItems}
                name={option.label}
              />
            )}
            onEnterCB={(option) => onEnterCB(option)}
            listSuffix={
              searchItems && searchItems.found ? (
                <ListSuffix searchInputValue={searchInputValue} />
              ) : (
                <ListSuffix
                  searchInputValue={searchInputValue}
                  noResults={true}
                />
              )
            }
          ></Select.SelectOptions>
        ) : null}
      </Select.SelectContainer>
    </div>
  );
};
